import React, {PureComponent} from 'react';

export default class RelativeParent extends PureComponent {
  render() {
    return (
      <div style={{position: 'relative'}}>
        {this.props.children}
      </div>
    )
  }
}
